import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft, ArrowRight } from "lucide-react";

export const ChatHeader = ({ onExit, onSwitch }) => (
  <header
    className="flex items-center justify-between px-4 sm:px-8 py-3"
    style={{
      background: "#0a0c12",
      borderBottom: "1px solid rgba(255,255,255,0.06)",
      height: 64,
    }}
  >
    <div className="flex items-center gap-3">
      <button
        onClick={onExit}
        className="p-2 rounded transition-colors"
        style={{
          background: "transparent",
          border: "1px solid rgba(255,255,255,0.10)",
          color: "#9198b0",
          cursor: "pointer",
        }}
        data-testid="ai-chat-exit"
        aria-label="Exit"
      >
        <ArrowLeft size={14} />
      </button>
      <div
        className="flex items-center justify-center rounded"
        style={{ width: 30, height: 30, background: "#185FA5", color: "#fff", fontFamily: "Syne, sans-serif", fontWeight: 700 }}
      >
        S
      </div>
      <div>
        <div style={{ fontFamily: "Syne, sans-serif", fontWeight: 600, fontSize: 16, color: "#f0f2f8" }}>
          AI Incident Assistant
        </div>
        <div
          style={{
            fontFamily: "'DM Mono', monospace",
            fontSize: 9,
            color: "#9198b0",
            letterSpacing: "1.5px",
            textTransform: "uppercase",
          }}
        >
          Natural-language registration
        </div>
      </div>
      <span
        className="ml-2 inline-flex items-center gap-1 px-2 py-1 rounded"
        style={{
          background: "rgba(155,89,182,0.15)",
          border: "1px solid rgba(155,89,182,0.45)",
          color: "#c89adb",
          fontFamily: "'DM Mono', monospace",
          fontSize: 9,
          letterSpacing: "1.2px",
          textTransform: "uppercase",
        }}
        data-testid="ai-chat-claude-badge"
      >
        <Sparkles size={10} /> Claude Sonnet
      </span>
    </div>
    <button
      onClick={onSwitch}
      className="px-3 py-2 rounded transition-colors hidden sm:flex items-center gap-2"
      style={{
        background: "transparent",
        border: "1px solid rgba(255,255,255,0.10)",
        color: "#9ec3ec",
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        letterSpacing: "0.4px",
        cursor: "pointer",
      }}
      data-testid="ai-chat-switch-link"
    >
      Switch to wizard <ArrowRight size={12} />
    </button>
  </header>
);

// ---------------- Bubble ----------------
